import "../css/CartResume.css";
import { useDispatch, useSelector } from "react-redux";

function CartResume() {
  const orderContent = useSelector((state) => state.shoppingCart.content);
  const totalCost = orderContent.reduce(
    (previousTotal, product) => previousTotal + product.quantity * product.sellingPrice,
    0,
  );
  const dispatch = useDispatch();

  return (
    <div className="mt-5 mb-5">
      <h3 className="ps-2">My order:</h3>
      <table className="table">
        <tr>
          <th className="products-column">Product</th>
          <th className="pe-3 text-center">Quantity</th>
          <th className="text-center">Cost</th>
        </tr>
        {orderContent.map((product) => (
          <tr key={product.id}>
            <td className="products-column">{product.name}</td>
            <td className="pe-3 text-center">{product.quantity}</td>
            <td className="text-center">
              U$S {(product.quantity * product.sellingPrice).toFixed(2)}
            </td>
          </tr>
        ))}
        <tr>
          <td className="fw-bold">TOTAL:</td>
          <td></td>
          <td className="fw-bold text-center">{`U$S ${totalCost.toFixed(2)}`}</td>
        </tr>
      </table>

      <button
        className="btn btn-main rounded-pill border p-2 text-center confirm-button"
        onClick={() => dispatch({ type: "TOGGLE_CART_VISIBILITY" })}
      >
        <i className="fa-solid fa-arrow-right pe-2"></i>
        Edit Order
      </button>
    </div>
  );
}

export default CartResume;
